import { times } from "lodash";

import { Shadows } from "@mui/material/styles/shadows";

const lightShadows: { [key: number]: string } = {
  0: "none",
  1: "0px 4px 6px -4px rgba(0, 0, 0, 0.16), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  2: "0px 6px 10px -6px rgba(0, 0, 0, 0.16), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  4: "0px 6px 16px -6px rgba(0, 0, 0, 0.16), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  8: "0px 8px 20px -6px rgba(0, 0, 0, 0.16), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  16: "0px 8px 28px -6px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  20: "0px 16px 34px -6px rgba(0, 0, 0, 0.18), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  22: "0px 20px 40px -8px rgba(0, 0, 0, 0.18), 0px 0px 1px rgba(0, 0, 0, 0.04)",
  24: "0px 28px 48px -8px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.04)",
};

const darkShadows: { [key: number]: string } = {
  0: "none",
  1: "0px 2px 4px rgba(0, 0, 0, 0.24), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  2: "0px 4px 8px rgba(0, 0, 0, 0.24), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  4: "0px 6px 16px rgba(0, 0, 0, 0.32), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  8: "0px 6px 16px rgba(0, 0, 0, 0.32), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  16: "0px 8px 24px rgba(0, 0, 0, 0.4), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  20: "0px 12px 32px rgba(0, 0, 0, 0.48), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  22: "0px 14px 36px rgba(0, 0, 0, 0.6), 0px 1px 1px rgba(0, 0, 0, 0.04)",
  24: "0px 14px 40px rgba(0, 0, 0, 0.8), 0px 1px 1px rgba(0, 0, 0, 0.04)",
};

// Creates all 24 shadows filling in gaps by repeating the previous shadow
const shadows = (mode: "light" | "dark" | "friendly"): Shadows => {
  const themeShadows = mode === "dark" ? darkShadows : lightShadows;

  let curShadow = "none";
  return times(25).map((shadowIndex) => {
    if (themeShadows[shadowIndex]) {
      curShadow = themeShadows[shadowIndex];
    }
    return curShadow;
  }) as Shadows;
};

export default shadows;
